import { Shape } from "./shape";


export class teamUndefined extends Shape{
    override width: number = 300;
    override height: number = 25;
    override color: string = "#ccc";
    override strokeColor: string = "#666";
    override strokeDashArray: [number, number] = [2.5, 2.5];
    
    

    constructor() {
        super();
    }

}